import * as React from 'react';

import { NamedDiscountDTO, Res } from 'core/api';
import * as SalesStore from '../SalesStore';
import { CustomerDisplay } from 'pos/services';
import { getAuthorizerUserIdForDiscount } from 'pos/modules/helpers/named-discount-authorization';
import { Message } from 'core/ui-next/modal';

// Este fichero ya no pinta pantalla. Sólo exporta la funcionalidad de los descuentos con nombre del ticket
// (lo que antes era la clase SetNamedDiscount) migrada a un hook, para que la use setTicketDiscountScreen
// en la pestaña "Descuentos".

export type TicketNamedDiscountParams = {
	// La pantalla nos pasa el close del Modal para poder cerrarla igual que hacía el this.close() de la clase
	close: () => void;
};

export type TicketNamedDiscount = {
	applyDiscount: (discount: NamedDiscountDTO) => Promise<void>;
};

export function useTicketNamedDiscount({ close }: TicketNamedDiscountParams): TicketNamedDiscount {

	const removeDiscount = React.useCallback(async (discount: NamedDiscountDTO) => {

		if (!discount.IsAllowed) {
			await Message.show(Res.Msg.MSG_HAVE_NOT_PERMISSION_TO_REMOVE_DISCOUNT());
			return;
		}

		// Tengo que quitar todos los descuentos porque este método solo se llama cuando se selecciona el descuento "Ninguno" en el diálogo de descuentos
		await SalesStore.setTicketDiscounts(0, 0);
		await CustomerDisplay.displayDiscounts(SalesStore.getTicket());
		close();

	}, [close]);

	const addDiscount = React.useCallback(async (discount: NamedDiscountDTO) => {

		if (!discount.IsAllowed && !discount.RequiresAuthorization) {
			await Message.show(Res.Msg.MSG_HAVE_NOT_PERMISSION_TO_APPLY_DISCOUNT(discount.Name));
			return;
		}

		const result = await getAuthorizerUserIdForDiscount({ discount, getProposal: SalesStore.getNamedDiscountProposal });
		if (!result.ok)
			return;

		await SalesStore.setTicketNamedDiscount(discount.Id, result.value);
		await CustomerDisplay.displayDiscounts(SalesStore.getTicket());
		close();

	}, [close]);

	const applyDiscount = React.useCallback(async (discount: NamedDiscountDTO) => {
		if (discount.Id === 0)
			await removeDiscount(discount);
		else
			await addDiscount(discount);
	}, [addDiscount, removeDiscount]);

	return { applyDiscount };
}
